/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Spin,
  Col,
  Modal,
  Input,
} from 'antd';
import Table from 'components/Table';
import { onError } from 'utils/handlers';
import PercentageInput from 'components/PercentageInput';
import percentFormatter from 'utils/percentFormatter';
import FormSubmitControls from 'components/FormSubmitControls';
import { formatReceived } from 'utils/formatValues';
import { getEstadosGlobales } from 'api/catalogos';
import { getTiposDeDepositos } from 'api/catalogos/tiposDeDepositos';
import { getBancos } from 'api/configuraciones/bancos';
import {
  getBeneficiariosExternos,
  postBeneficiarioExterno,
  patchBeneficiarioExterno,
  deleteBeneficiarioExterno,
  getBeneficiarioExterno,
} from 'api/nominas/descuentos/beneficiariosExternos';
import Select from 'components/Select';
import ModalDelete from 'components/ModalDelete';
import { getMetodosDePagos } from 'api/catalogos/metodosDePagos';
import { FLOAT_NUMER_PATTERN } from 'utils/patterns';
import { ESTATUS_ACTIVO, ESTATUS_INACTIVO } from 'utils/constants';

export const beneficiariosExternosPermission = {
  permissionModel: 'beneficiarioexterno',
  catalogsModels: [],
  tabsModels: [],
};

const BeneficiariosExternos = ({
  permissions,
  selected,
  disable,
  isBlocked,
}) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [data, setData] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visibleAlert, setVisibleAlert] = useState();
  const [estados, setEstados] = useState([]);
  const [metodosDePagos, setMetodosDePagos] = useState([]);
  const [esTransferencia, setEsTransferencia] = useState(false);
  const [tiposDepositos, setTiposDepositos] = useState([]);
  const [esClabe, setEsClabe] = useState(false);
  const [bancos, setBancos] = useState([]);
  const [formFormaPago] = Form.useForm();
  const [porcentajes, setPorcentajes] = useState(0);
  const [editable, setEditable] = useState(false);
  const [porcentajeSeleccionado, setPorcentajeSeleccionado] = useState(0);
  const [dataFiltered, setDataFiltered] = useState([]);
  let error = false;
  let porcentajesTotal = 0;

  const formInstances = [
    form,
    formDatos,
    formFormaPago,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getBeneficiariosExternos({ descuento_empleado: selected });
    setData(formatReceived(_data));
    // eslint-disable-next-line
    const _dataFiltered = await getBeneficiariosExternos({ descuento_empleado: selected ,estados_globales: 1 });
    setDataFiltered(formatReceived(_dataFiltered));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _estados,
        _data,
        _dataFiltered,
        _tiposDepositos,
        _bancos,
        _metodosDePagos,
      ] = await Promise.all([
        getEstadosGlobales(),
        getBeneficiariosExternos({ descuento_empleado: selected }),
        getBeneficiariosExternos({ descuento_empleado: selected, estados_globales: 1 }),
        getTiposDeDepositos(),
        getBancos(),
        getMetodosDePagos(),
      ]);
      if (mounted) {
        if (selected) {
          setEstados(_estados);
          setData(formatReceived(_data));
          setDataFiltered(formatReceived(_dataFiltered));
          setTiposDepositos(_tiposDepositos);
          setBancos(_bancos);
          setMetodosDePagos(_metodosDePagos);
          setLoading(false);
        } else {
          setData([]);
          setLoading(false);
        }
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    setEsTransferencia(false);
    setEditable(false);
    setEsClabe(false);
    error = false;
    form.resetFields();
    formDatos.resetFields();
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setEditable(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _beneficiarioExterno = await getBeneficiarioExterno(match.id);
    setPorcentajeSeleccionado(_beneficiarioExterno.porcentaje);
    setTimeout(() => {
      if (_beneficiarioExterno) {
        setTimeout(() => {
          form.setFieldValue(formatReceived(_beneficiarioExterno));
          formDatos.setFieldValue(formatReceived(_beneficiarioExterno));
          setVisible(true);
          if (_beneficiarioExterno.metodo_de_pago === 3) {
            setEsTransferencia(true);
          } else {
            setEsTransferencia(false);
            form.resetFields(['tipo_de_deposito', 'banco', 'numero_de_cuenta', 'clabe']);
          }
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchBeneficiarioExterno(key, { ...values, descuento_empleado: selected }) : postBeneficiarioExterno({ ...values, descuento_empleado: selected }));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteBeneficiarioExterno(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const handleMetodoPagoChange = (value) => {
    const clave = metodosDePagos.find((metodoPago) => metodoPago.id === value)?.clave;
    // +clave es una conversion implicita de string a int.
    if (+clave === 3) {
      setEsTransferencia(true);
    } else {
      setEsTransferencia(false);
      form.resetFields(['tipo_de_deposito', 'banco', 'numero_de_cuenta', 'clabe']);
    }
  };

  const handleTipoDepositoChange = (value) => {
    const deposito = tiposDepositos.find((tipoDeposito) => tipoDeposito.id === value)?.id;
    if (deposito === 2) {
      setEsClabe(true);
      form.resetFields(['numero_de_cuenta']);
    } else {
      setEsClabe(false);
      form.resetFields(['clabe']);
    }
  };

  const porcentajeChange = (value) => {
    const percentArray = [];
    porcentajesTotal = 0;
    setPorcentajes(0);
    if (editable === true) {
      for (let i = 0; i < dataFiltered.length; i += 1) {
        percentArray.push(dataFiltered[i].porcentaje);
        if (porcentajeSeleccionado === percentArray[i]) {
          percentArray[i] = value;
        }
        porcentajesTotal += percentArray[i];
      }
    } else {
      for (let i = 0; i < dataFiltered.length; i += 1) {
        percentArray.push(dataFiltered[i].porcentaje);
        porcentajesTotal += percentArray[i];
      }
      setPorcentajes(porcentajesTotal);
    }
  };

  const changeEstatus = (value) => {
    const [key] = selectedRowKeys;
    const match = data.find((item) => item.id === key)?.porcentaje;
    const estado = data.find((item) => item.id === key)?.estados_globales;
    const percentArray = [];
    porcentajesTotal = 0;
    for (let i = 0; i < dataFiltered.length; i += 1) {
      percentArray.push(dataFiltered[i].porcentaje);
      porcentajesTotal += percentArray[i];
    }
    if (value === ESTATUS_INACTIVO) {
      setPorcentajes(porcentajesTotal - match);
    } else if (value === ESTATUS_ACTIVO) {
      if (estado === ESTATUS_ACTIVO) {
        setPorcentajes(porcentajesTotal);
      } else if (estado === ESTATUS_INACTIVO) {
        if (porcentajesTotal + match > 100) {
          setPorcentajes(porcentajesTotal);
          error = true;
        } else {
          setPorcentajes(porcentajesTotal);
        }
      }
    }
  };

  useEffect(() => {
    handleMetodoPagoChange(formFormaPago.getFieldValue('metodo_de_pago'));
  }, [formFormaPago]);

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    porcentajeExcedente: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
      {
        validator: async (_, value) => {
          if (porcentajes + value > 100 || porcentajesTotal > 100) {
            throw new Error('La totalidad de los porcentajes no puede superar el 100%');
          }
        },
      },
    ],
    numeroCuenta: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
      {
        validator: async (_, value) => {
          if (value?.length <= 12) {
            throw new Error('Numero de cuenta no válido');
          }
          if (value?.length >= 18) {
            throw new Error('Numero de cuenta no válido');
          }
        },
      },
    ],
    clabe: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
      {
        validator: async (_, value) => {
          if (value?.length <= 12) {
            throw new Error('CLABE no válida');
          }
          if (value?.length >= 18) {
            throw new Error('CLABE no válida');
          }
        },
      },
    ],
    estatus: [
      requiredRule,
      {
        validator: async () => {
          if (error === true) {
            throw new Error('No se puede activar, porcentaje será mayor a 100');
          }
        },
      },
    ],
  };

  const columns = [
    {
      titleText: 'Nombre del Beneficiario(a)',
      dataIndex: 'nombre_del_beneficiario',
      key: 'nombre_del_beneficiario',
      width: 300,
    },
    {
      titleText: 'Relación Familiar o Civil',
      dataIndex: 'relacion_familiar_civil',
      key: 'relacion_familiar_civil',
      width: 210,
    },
    {
      titleText: 'Porcentaje',
      dataIndex: 'porcentaje',
      key: 'porcentaje',
      width: 200,
      render: (val) => percentFormatter(val || 0),
    },
    {
      titleText: 'Forma de Pago',
      dataIndex: 'metodo_de_pago',
      key: 'metodo_de_pago',
      width: 200,
      render: (val) => metodosDePagos.find((e) => e.id === val)?.concepto,
    },
    {
      titleText: 'Banco',
      dataIndex: 'id',
      key: 'banco',
      width: 200,
      render: (val) => {
        const beneficiario = data.find((e) => e.id === val);
        if (beneficiario?.metodo_de_pago === 3) {
          return bancos.find((e) => e.id === beneficiario?.banco)?.nombre;
        }
        return '';
      },
    },
    {
      titleText: 'No. de Cuenta',
      dataIndex: 'id',
      key: 'numero_de_cuenta',
      width: 200,
      render: (val) => {
        const beneficiario = data.find((e) => e.id === val);
        if (beneficiario?.metodo_de_pago === 3) {
          return beneficiario.numero_de_cuenta;
        }
        return '';
      },
    },
    {
      titleText: 'CLABE',
      dataIndex: 'id',
      key: 'clabe',
      width: 200,
      render: (val) => {
        const beneficiario = data.find((e) => e.id === val);
        if (beneficiario?.metodo_de_pago === 3) {
          return beneficiario.clabe;
        }
        return '';
      },
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          allowExport
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          allowDelete={!disable}
          permission={permissions}
          allowExportPDF={false}
          disableAdd={disable || isBlocked}
        />
        <Modal
          open={open}
          width={700}
          closable={false}
          maskClosable={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Beneficiario Externo`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disable}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            name="general"
            disabled={disable}
          >
            <Row gutter={10}>
              <Col span={12}>
                <Form.Item
                  name="nombre_del_beneficiario"
                  label="Nombre del Beneficiario(a)"
                  rules={rules.required}
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled={disable || isBlocked}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="relacion_familiar_civil"
                  label="Relación Familiar o Civil"
                  rules={rules.required}
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled={disable || isBlocked}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={10}>
              <Col span={12}>
                <PercentageInput
                  name="porcentaje"
                  label="Porcentaje"
                  onChange={porcentajeChange}
                  rules={rules.porcentajeExcedente}
                  disabled={disable || isBlocked}
                />
              </Col>
              <Col span={12}>
                <Form.Item
                  name="metodo_de_pago"
                  label="Forma de Pago"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    dataSource={metodosDePagos}
                    onChange={handleMetodoPagoChange}
                    labelProp="concepto"
                    disabled={isBlocked}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={10}>
              <Col span={12}>
                <Form.Item
                  name="tipos_de_depositos"
                  label="Tipo de Depósito"
                  rules={esTransferencia ? rules.required : null}
                  hasFeedback
                >
                  <Select
                    dataSource={tiposDepositos}
                    onChange={handleTipoDepositoChange}
                    labelProp="concepto"
                    disabled={!esTransferencia || isBlocked}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="banco"
                  label="Banco"
                  rules={esTransferencia ? rules.required : null}
                  hasFeedback
                >
                  <Select
                    dataSource={bancos}
                    labelProp="nombre"
                    disabled={!esTransferencia || isBlocked}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="numero_de_cuenta"
                  label="No. de Cuenta"
                  rules={esTransferencia && !esClabe ? rules.numeroCuenta : null}
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled={!esTransferencia || esClabe || isBlocked}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="clabe"
                  label="CLABE"
                  rules={esTransferencia && esClabe ? rules.clabe : null}
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled={!esTransferencia || !esClabe || isBlocked}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="estados_globales"
                label="Estatus"
                rules={rules.estatus}
                hasFeedback
                initialValue={1}
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={estados}
                  onChange={changeEstatus}
                  disabled={!editable || isBlocked}
                />
              </Form.Item>
            </Col>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Beneficiario Externo ${form.getFieldValue('nombre_del_beneficiario')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};
export default BeneficiariosExternos;
